import { endpoint } from './default';

const getLoginWatch = () => endpoint.get('/login_watch/all', {
  params: {
    tag: 'CodingWizard',
  },
});

const getLoginWatchById = (cwid) => endpoint.get(`/login_watch/${cwid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getLoginWatchBetweenDate = (from, to) => endpoint.get(`/login_watch/between/${from}/${to}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getLoginWatchHour = (from, to) => endpoint.get(`/login_watch/between/hour/${from}/${to}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const createLoginWatch = (data) => endpoint.post('/login_watch', data, {
  params: {
    tag: 'CodingWizard',
  },
});

const updateLoginWatch = (data, id) => endpoint.put(`/login_watch/${id}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

const deleteLoginWatch = (id) => endpoint.delete(`/login_watch/delete/${id}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

const getLoginPercentage = (from, to) => endpoint.get(`/login_watch/analysis/details/${from}/${to}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getOnlineNum = (time) => endpoint.get(`/login_watch/online/${time}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getOnlineList = (time) => endpoint.get(`/login_watch/online/cw_info/${time}`, {
  params: {
    tag: 'CodingWizard',
  },
});

export {
  getLoginWatch,
  getLoginWatchById,
  getLoginWatchBetweenDate,
  getLoginWatchHour,
  createLoginWatch,
  updateLoginWatch,
  deleteLoginWatch,
  getLoginPercentage,
  getOnlineList,
  getOnlineNum,
};
